import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function Attachment(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M16.663227,13.835664 C17.0537513,13.4451398 17.6869163,13.4451398
          18.0774406,13.835664 C18.4679649,14.2261883 18.4679649,14.8593533
          18.0774406,15.2498776 L13.7764086,19.5509096 C11.5399199,21.7873983
          7.91385523,21.7873983 5.67736653,19.5509096 C3.44087782,17.3144209
          3.44087782,13.6883563 5.67736653,11.4518676 L12.9133587,4.21587538
          C14.534526,2.59470819 17.1629574,2.59470821 18.7841246,4.21587543
          C20.4052918,5.83704264 20.4052918,8.46547402 18.78374,10.0870257
          L11.5402586,17.3226335 C10.5344129,18.3284792 8.90361468,18.3284792
          7.89776892,17.3226335 C6.89192316,16.3167877 6.89192316,14.6859895
          7.89818572,13.6797272 L12.2528571,9.330185 C12.6436114,8.9398909
          13.2767763,8.94026401 13.6670704,9.33101836 C14.0573645,9.72177271
          14.0569914,10.3549376 13.666237,10.7452317 C11.9727537,12.4367203
          11.9727537,12.4367203 9.31198248,15.0943573 C9.0871853,15.3191545
          9.0871853,15.6836227 9.31198248,15.9084199 C9.53677966,16.1332171
          9.9012479,16.1332171 10.1264297,15.9080355 L17.369911,8.67242772
          C18.2100297,7.83230907 18.2100297,6.47020763 17.369911,5.63008899
          C16.5297924,4.78997035 15.1676909,4.78997034 14.3275723,5.63008895
          L7.09158009,12.8660812 C5.63613997,14.3215213 5.63613997,16.6812559
          7.09158009,18.1366961 C8.54702021,19.5921362 10.9067549,19.5921362
          12.362195,18.1366961 L16.663227,13.835664 Z"
      />
    </SvgIcon>
  );
}
